"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_i18next_1 = require("react-i18next");
var MediaLibrary_module_css_1 = __importDefault(require("./MediaLibrary.module.css"));
var CustomEmpty = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { className: MediaLibrary_module_css_1.default["empty-status-container"] },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faFolderOpen, size: "5x", className: MediaLibrary_module_css_1.default["empty-folder-icon"] }),
        react_1.default.createElement("p", { className: "".concat(MediaLibrary_module_css_1.default["empty-first-paragraph"], " ns-font-family") }, t("No Media Library Items Found"))));
};
exports.default = CustomEmpty;
